module.exports = __webpack_public_path__ + "img/DSC_1139.dfe30db7.jpg";